import apiClient from './client'

/**
 * Obtiene la lista de eventos con filtros
 */
export const getEventos = async (filters = {}) => {
  const {
    page = 1,
    pageSize = 20,
    estadoEvento,
    idCentroTrabajo,
    textoBusqueda,
    ...otherFilters
  } = filters

  const params = {
    page,
    pageSize,
    ...otherFilters,
  }

  // Solo añadir filtros si tienen valor
  if (estadoEvento) params.estadoEvento = estadoEvento
  if (idCentroTrabajo) params.idCentroTrabajo = idCentroTrabajo
  if (textoBusqueda) params.textoBusqueda = textoBusqueda

  const response = await apiClient.get('/api/radar/eventos', { params })

  // La respuesta tiene estructura: { code, payload: { Eventos, Pagination }, message }
  return response.data
}

/**
 * Obtiene un evento por ID
 */
export const getEvento = async (id) => {
  const response = await apiClient.get(`/api/radar/eventos/${id}`)
  // La respuesta tiene estructura: { code, payload: { evento, atenciones, imagenes, comentarios }, message }
  return response.data
}

/**
 * Actualiza un evento
 */
export const updateEvento = async (id, data) => {
  const response = await apiClient.put(`/api/radar/eventos/${id}`, data)
  // La respuesta tiene estructura: { code, payload: { eventoActualizado: true }, message }
  return response.data
}

/**
 * Obtiene los tipos de anomalía
 */
export const getTiposAnomalia = async () => {
  const response = await apiClient.get('/api/radar/tipos-anomalia')
  // La respuesta tiene estructura: { code, payload: [...], message }
  return response.data
}

/**
 * Elimina un evento
 */
export const deleteEvento = async (id) => {
  const response = await apiClient.delete(`/api/radar/eventos/${id}`)
  // La respuesta tiene estructura: { code, payload: { eventoEliminado: true }, message }
  return response.data
}

/**
 * Obtiene el historial de cambios de un evento
 */
export const getEventoHistorial = async (id) => {
  const response = await apiClient.get(`/api/radar/eventos/${id}/historial`)
  // La respuesta tiene estructura: { code, payload: { idEvento, historial: [...], totalCambios }, message }
  return response.data
}

/**
 * Obtiene el conteo de eventos agrupados por estado
 * Endpoint optimizado que devuelve solo conteos numéricos sin datos completos
 *
 * @param {Object} filters - Filtros opcionales (idCentroTrabajo, severidad, idTipoAnomalia, fechaDesde, fechaHasta, etc.)
 * @returns {Promise} - { code, payload: { ConteoPorEstado: [...], Total }, message }
 *
 * Estructura de ConteoPorEstado:
 * [
 *   { EstadoEvento: 1, EstadoTexto: "Nuevo", Cantidad: 15 },
 *   { EstadoEvento: 2, EstadoTexto: "Visto", Cantidad: 8 },
 *   { EstadoEvento: 3, EstadoTexto: "EnProceso", Cantidad: 12 },
 *   { EstadoEvento: 4, EstadoTexto: "Resuelto", Cantidad: 45 },
 *   { EstadoEvento: 5, EstadoTexto: "Descartado", Cantidad: 3 }
 * ]
 *
 * Filtros disponibles:
 * - idCentroTrabajo: Filtra por centro de trabajo
 * - idInvernadero: Filtra por invernadero
 * - severidad: Filtra por severidad (1-5)
 * - idTipoAnomalia: Filtra por tipo de anomalía
 * - requiereAtencion: Solo eventos que requieren atención (boolean)
 * - soloMisReportes: Solo eventos del usuario autenticado (boolean)
 * - fechaDesde/fechaHasta: Rango de fechas (ISO 8601)
 * - textoBusqueda: Búsqueda en descripción
 */
export const getEventosConteoPorEstado = async (filters = {}) => {
  const {
    idCentroTrabajo,
    idInvernadero,
    severidad,
    idTipoAnomalia,
    requiereAtencion,
    soloMisReportes,
    fechaDesde,
    fechaHasta,
    textoBusqueda,
    ...otherFilters
  } = filters

  const params = { ...otherFilters }

  // Solo añadir filtros si tienen valor
  if (idCentroTrabajo) params.idCentroTrabajo = idCentroTrabajo
  if (idInvernadero) params.idInvernadero = idInvernadero
  if (severidad) params.severidad = severidad
  if (idTipoAnomalia) params.idTipoAnomalia = idTipoAnomalia
  if (requiereAtencion !== undefined) params.requiereAtencion = requiereAtencion
  if (soloMisReportes !== undefined) params.soloMisReportes = soloMisReportes
  if (fechaDesde) params.fechaDesde = fechaDesde
  if (fechaHasta) params.fechaHasta = fechaHasta
  if (textoBusqueda) params.textoBusqueda = textoBusqueda

  const response = await apiClient.get('/api/radar/eventos/conteo-por-estado', { params })

  // La respuesta tiene estructura: { code, payload: { ConteoPorEstado: [...], Total }, message }
  return response.data
}
